import { render, staticRenderFns } from "./RevisionSingleContainer.vue?vue&type=template&id=06e772ed&scoped=true"
import script from "./RevisionSingleContainer.vue?vue&type=script&lang=js"
export * from "./RevisionSingleContainer.vue?vue&type=script&lang=js"
import style0 from "./RevisionSingleContainer.vue?vue&type=style&index=0&id=06e772ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e772ed",
  null
  
)

export default component.exports